import { slugify } from '@src/utils/slugify';
import {
  likelihoodOrder,
  extractFilterValues,
  extractGradeFromGcseRow,
} from '@src/components/DynamicTable/helpers';

export const enhanceGcseTopicColumns = (columns, { rows = [] } = {}) => {
  console.log('gcseCols: ', columns);
  // columns here are already enhanced by defaultColumnEnhancer with basic sorting
  // We only need to add more complex sorting for specific cases
  const enhancedColumns = columns
    .map((col) => {
      const id = slugify(col.id); // Use existing id, just slugify for comparison

      switch (id) {
        case 'likelihood':
          return {
            ...col,
            sortingFn: (rowA, rowB, columnId) => {
              const getLikelihoodValue = (row) => {
                console.log(row);
                const likelihood = row.original.edexcelGcseColumnThree?.title ?? '';
                return likelihoodOrder[likelihood] ?? 0; // Default to 0 for unknown likelihood
              };

              const valueA = getLikelihoodValue(rowA);
              const valueB = getLikelihoodValue(rowB);

              return valueA - valueB;
            },
          };
        case 'grade':
          return {
            ...col,
            sortingFn: (rowA, rowB, columnId) => {
              const getGradeValue = (row) => {
                const grade = row.original.edexcelGcseColumnTwo;
                // Handle null/undefined values
                if (grade == null) return 0;

                // If it's already a number, return it
                if (typeof grade === 'number') return grade;

                // If it's a string, try to parse it
                if (typeof grade === 'string') {
                  const parsed = parseFloat(grade);
                  return isNaN(parsed) ? 0 : parsed;
                }

                // Default to 0 for any other type
                return 0;
              };

              const valueA = getGradeValue(rowA);
              const valueB = getGradeValue(rowB);

              return valueA - valueB;
            },
          };

        default:
          // Keep the default enhanced column (sortable already determined by presence of sortingFn)
          return col;
      }
    })
    .filter(Boolean);

  // Extract filter values if rows are provided
  if (rows.length > 0) {
    const gradeValues = extractFilterValues(rows, extractGradeFromGcseRow);

    // Add filter metadata to the columns object
    if (gradeValues.length > 0) {
      enhancedColumns.filterControls = {
        gradeValues: gradeValues.sort((a, b) => a - b),
      };
    }
  }

  return enhancedColumns;
};

export default enhanceGcseTopicColumns;
